import { CloudCommand } from "../types.js";

export const getLeadsLists: CloudCommand = {
    action: "SALES/GET_LEADS_LISTS",
    commandName: "sales.getLeadsLists",
    buildPayload: ({ start, count }) => ({ start, count }),
};
